import React from 'react';
export function ThankYouSlide() {
  return <div className="flex flex-col w-screen h-screen overflow-hidden bg-white text-[#1a1a2e] relative" data-id="element-570">
      {/* Subtle background grid */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
      backgroundImage: `radial-gradient(circle, #1a1a2e 1px, transparent 1px)`,
      backgroundSize: '32px 32px'
    }} data-id="element-571" />

      {/* Top Header */}
      <div className="flex justify-between items-start shrink-0 px-8 py-6 relative z-10" data-id="element-572">
        <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2 Logo" className="h-8 w-auto object-contain" data-id="element-573" />
      </div>

      {/* Main Content — Centered */}
      <div className="flex-grow flex flex-col items-center justify-center relative z-10 px-8 -mt-6" data-id="element-574">
        {/* Thank You */}
        <h1 className="text-[3rem] font-bold text-[#1a1a2e] text-center leading-tight mb-4" data-id="element-575">
          Thank You
        </h1>

        {/* Subtle divider */}
        <div className="w-16 h-1 bg-[#2EBCB0] rounded-full mb-6" data-id="element-576" />

        {/* Subtitle */}
        <p className="text-[1.05rem] text-gray-500 text-center max-w-lg leading-relaxed mb-14" data-id="element-577">
          We look forward to collaborating on building a smarter delivery
          ecosystem
        </p>

        {/* Contact Info */}
        <div className="flex flex-col items-center gap-1.5" data-id="element-578">
          <h2 className="text-[1.15rem] font-bold text-[#1a1a2e]" data-id="element-579">
            Fadi Rayyan
          </h2>
          <p className="text-[0.85rem] text-gray-500 font-medium" data-id="element-580">
            Managing Director – Pair2
          </p>

          <div className="h-4" data-id="element-581" />

          <a href="mailto:fadi@pair2.ae" className="text-[0.9rem] text-[#1a1a2e] hover:text-[#2EBCB0] transition-colors" data-id="element-582">
            fadi@pair2.ae
          </a>
          <a href="tel:+971585377090" className="text-[0.9rem] text-[#1a1a2e] hover:text-[#2EBCB0] transition-colors" data-id="element-583">
            +971 58 537 7090
          </a>

          <div className="h-6" data-id="element-584" />

          <span className="text-[0.8rem] text-gray-400 tracking-wide" data-id="element-585">
            pair2.ae
          </span>
        </div>
      </div>

      {/* Bottom spacer */}
      <div className="shrink-0 h-16" data-id="element-586" />
    </div>;
}